import { makeStyles } from '@rbx/ui';

const useEndpointsCategoryContainerStyle = makeStyles()(() => ({
  description: {
    marginTop: 24,
  },

  serverUrl: {
    marginTop: 24,
  },
}));

export default useEndpointsCategoryContainerStyle;
